import {
    cursoRealizandoEscolhasGestor,
    cursoRealizandoEscolhasProfessorEnsinoMedio,
    cursoRealizandoEscolhasProfessor9ano,
    idCursoRealizandoEscolhasGestor,
    idCursoRealizandoEscolhasProfessor9ano,
    idCursoRealizandoEscolhasProfessorEnsinoMedio,
} from 'constants/EnvironmentData';
import { getUserRole } from 'core/util/KeycloakHelp';
import { MatriculaLMSEnum } from 'enums/MatriculaLMSEnum';
import { ConcluidoNaoConcluidoEnum } from 'enums/ConcluidoNaoConcluidoEnum';
import { RoleEnum } from 'enums/RoleEnum';
import UsuarioDTO from 'models/UsuarioDTO';
import { useHistory } from 'react-router-dom';
import { ToastError } from 'components/Toaster';
import PerfilUsuario from 'models/perfil/PerfilUsuario';
import { Ocupation } from 'enums/Ocupation';
import { ProfileService } from 'core/http/service/Profile.service';
import AdminRecursosCostumizados from 'core/http/service/admin/AdminRecursosCostumizados.service';

export const buscarOcupacaoPorPerfil = (usuario: PerfilUsuario | null) => {
    const ocupacao = usuario?.ocupacao;

    if (ocupacao === Ocupation.Professor) {
        return 'A';
    } else if (
        ocupacao === Ocupation.OrientadorPedagogico ||
        ocupacao === Ocupation.CoordenadorPedagogico ||
        ocupacao === Ocupation.ViceDiretor ||
        ocupacao === Ocupation.Diretor ||
        ocupacao === Ocupation.GestorEscolar
    ) {
        return 'B';
    } else {
        return 'C';
    }
};

export const buscarCategoriaPorPerfil = async (usuarioLogado: UsuarioDTO) => {
    let role = RoleEnum.Unknown;

    if (usuarioLogado) {
        if (usuarioLogado.roles.length <= 3) {
            const profileService = new ProfileService();
            const { data } = await profileService.findByUsername(usuarioLogado.username);

            const _perfil = new PerfilUsuario().fromJSON(data);
            role = _perfil.role;
        }

        const roleUser: RoleEnum = getUserRole(usuarioLogado.roles)[0];
        role = roleUser ? roleUser : role;

        if (role == RoleEnum.Professor || role == RoleEnum.Outro) {
            return 'A';
        } else if (role == RoleEnum.CoordenadorNaoParceiro || role == RoleEnum.Diretor || role == RoleEnum.TecnicoEducacao) {
            return 'B';
        }
    }
};

export const redirectToTrilhaFormativaLMS = async (role: string, is9Ano: boolean, usuarioLogado: UsuarioDTO, callbackLoading: any): Promise<string> => {

    if(usuarioLogado){

        if (role == 'A') {
            if (is9Ano) {
                return '/recursos/jornada-realizando-escolhas/trilha-formativa-professor-9ano';
            } else {
               return '/recursos/jornada-realizando-escolhas/trilha-formativa-professor-ensino-medio';
            }
        } else if (role == 'B') {
            return '/recursos/jornada-realizando-escolhas/trilha-formativa-gestor';
        }
    }

    return "/painelSocioemocional";

};



export const redirectToInstrumento = async (
    userRole: string,
    callbackErro: (show: boolean) => void,
    usuarioLogado: UsuarioDTO,
    callbackSucesso: () => void
) => {
    const serviceRecursosCostumizados = new AdminRecursosCostumizados();

    if (userRole == 'A') {
        const res9ano = await serviceRecursosCostumizados.listByEtapasAndConteudosResumidos(34);

        if (res9ano.status === 200 && res9ano.data.isConcluido) {
            return callbackSucesso();
        }

        const resEnsMedio = await serviceRecursosCostumizados.listByEtapasAndConteudosResumidos(35);

        if (resEnsMedio.status === 200 && resEnsMedio.data.isConcluido) {
            return callbackSucesso();
        }

        callbackErro(true);
    } else if (userRole == 'B') {
        const resGestor = await serviceRecursosCostumizados.listByEtapasAndConteudosResumidos(36);

        if (resGestor.status === 200 && resGestor.data.isConcluido) {
            return callbackSucesso();
        }

        return callbackErro(true);
    } else {
        callbackErro(true);
    }
};

